<template>
	<article class="d-content-page-custom relative">
		<HeroItem :data="heroMedia" :title="title" />
		<ContactButton :content="contactpersons" />
		<Facts :data="facts" class="hidden >=768:block" />
		<div
			v-if="description"
			class="rte mt-40 text-18 >=786:mt-60 >=768:text-24 >=768:w-3/4"
			v-html="description"
		></div>
		<Facts :data="facts" class="<768:block >=768:hidden" />
		<BlockList :block-list="contentElements" />
	</article>
</template>

<script>
import HeroItem from '~/components/main/HeroItem';
import BlockList from '~/components/main/BlockList';
import Facts from '~/components/main/Facts';
import ContactButton from '~/components/main/ContactButton';

export default {
	name: 'MainContentPageCustom',

	components: {
		HeroItem,
		BlockList,
		Facts,
		ContactButton,
	},

	inheritAttrs: false,

	props: {
		title: String,
		heroMedia: Object,
		contentElements: Array,
		facts: Array,
		description: String,
		contactpersons: Array,
	},
};
</script>
<style lang="postcss">
.rte h2 {
	@apply uppercase;
	@apply text-32;
	@apply text-blue;
	@apply mb-30;
	@apply leading-initial;

	font-weight: 700;
}

.rte a {
	@apply underline;
}

@screen >=768 {
	.rte h2 {
		@apply text-48;
	}
}
</style>
